import React, { useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoggedOut } from "redux/features/auth";
import { NavbarLink } from "util/navbarLink";
import IconButton from "util/iconButton";
import { FaSignOutAlt } from "react-icons/fa";
import { modalSlice } from "redux/features/modal";

import { Navbar, Element } from "react-bulma-components";

import Loading from "util/loading";

import logo from "media/fields-logo.png";

export function TopBar(props) {
  const { authStatus, loading, profileFullName, staffUsername } = props;

  const [burgerOpen, setBurgerOpen] = useState(false);
  const dispatch = useDispatch();
  const modal = useSelector(modalSlice.selector);

  const handleBurgerToggle = () => setBurgerOpen(!burgerOpen);
  const navigate = useNavigate();
  const handleLogout = () => {
    dispatch(setLoggedOut());
    navigate("");
  };

  const brandItems = profileFullName ? (
    <Navbar.Item className="is-spaced topbar-username" renderAs="div">
      {staffUsername ? (
        <NavbarLink to=".." className="topbar-exit-user">
          <button className="delete is-large" />
        </NavbarLink>
      ) : null}
      <div className="pre-username-text">for</div>
      <div className="username-text">{profileFullName} </div>
    </Navbar.Item>
  ) : null;

  const leftMenuItems = null;

  const rightMenuItems = profileFullName ? (
    <Fragment>
      <Navbar.Item hoverable className="is-spaced">
        <Navbar.Link>Profile</Navbar.Link>
        <Navbar.Dropdown className="has-wrapped-text">
          <NavbarLink to="">Dashboard</NavbarLink>
          <Navbar.Divider />
          <NavbarLink to="basic/name">Name</NavbarLink>
          <NavbarLink to="basic/emails">Email Addresses</NavbarLink>
          <NavbarLink to="affiliation/current">
            Affiliation/Occupation
          </NavbarLink>
          <NavbarLink to="affiliation/past">Past Affiliations</NavbarLink>
          <NavbarLink to="demographics">Demographic Information</NavbarLink>
          <Navbar.Divider />
          <NavbarLink to="account">Account (Sign-in) Settings</NavbarLink>
        </Navbar.Dropdown>
      </Navbar.Item>
    </Fragment>
  ) : null;
  const authItems = (
    <Fragment>
      {staffUsername ? (
        <Navbar.Item renderAs="div">
          logged in as staff: &nbsp;
          <span className="has-text-weight-bold">{staffUsername}</span>
        </Navbar.Item>
      ) : null}
      {authStatus ? (
        <Navbar.Item renderAs="div" italic>
          {authStatus}
        </Navbar.Item>
      ) : null}

      {loading ? (
        <Navbar.Item renderAs="div">
          <Loading loading color="success" />
        </Navbar.Item>
      ) : null}

      {staffUsername || profileFullName ? (
        <Navbar.Item renderAs="div">
          <IconButton icon={FaSignOutAlt} onClick={handleLogout}>
            Log Out
          </IconButton>
        </Navbar.Item>
      ) : null}
    </Fragment>
  );
  const className = "ours" + (modal ? " disabled" : "");
  return (
    <Navbar color="success" className={className} active={burgerOpen}>
      <Navbar.Brand>
        <Navbar.Item renderAs="a" href="#">
          <img src={logo} alt="FIELDS" />
        </Navbar.Item>
        <Navbar.Item renderAs="div">
          <Element
            renderAs="div"
            textSize={4}
            textWeight="bold"
            textAlign="center"
          >
            Fields Institute
            <br />
            Personal Portal
          </Element>
        </Navbar.Item>
        {brandItems}
        <Navbar.Burger onClick={handleBurgerToggle} />
      </Navbar.Brand>

      <Navbar.Menu>
        <Navbar.Container>
          <Navbar.Item />
          {leftMenuItems}
        </Navbar.Container>
        <Navbar.Container align="right">
          {rightMenuItems}
          {authItems}
        </Navbar.Container>
      </Navbar.Menu>
    </Navbar>
  );
}

export default TopBar;
